<template>
	<el-card class="box-card">
		<div slot="header" class="clearfix">
			<span>添加账号</span>
		</div>
		<div style="background-color: white;display: flex;align-content: space-between;flex-wrap: wrap;">
			<el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="auto" :inline="false" style="width: 400px;">
				<el-form-item label="管理员姓名" prop="admin_name">
					<el-input v-model="form.admin_name"></el-input>
				</el-form-item>
				<el-form-item label="管理员手机号" prop="admin_tel">
					<el-input v-model="form.admin_tel"></el-input>
				</el-form-item>
				<el-form-item label="管理员职务" prop="admin_postion">
					<el-input v-model="form.admin_postion"></el-input>
				</el-form-item>
				<el-form-item label="登录密码" prop="admin_password">
					<el-input v-model="form.admin_password"></el-input>
				</el-form-item>
				<el-form-item label="请确认密码" prop="admin_password2">
					<el-input v-model="form.admin_password2"></el-input>
				</el-form-item>
				<div style="width: 100%;display: flex;justify-content: center;padding-top: 30px;">
					<el-button style="width: 200px;" type="primary" @click="resetForm">重置表单</el-button>
					<el-button style="margin-left: 50px;width: 200px;" type="primary" @click="addAdmin">添加账号</el-button>
				</div>
			</el-form>
			
		</div>
	</el-card>
</template>

<script>
	export default {
		data() {
			var admin_password2 = (rule, value, callback) => {
				if (value != this.form.admin_password) {
					return callback(new Error('两次密码不一致'));
				}
			}
			return {
				form: {
					admin_password:''
				},
				rules: {
					admin_name: [{
						required: true,
						message: '请输入管理员名称',
						trigger: 'change'
					}],
					admin_tel: [{
						required: true,
						message: '请输入管理员手机号',
						trigger: 'change'
					}],
					admin_postion: [{
						required: true,
						message: '请输入管理员职务',
						trigger: 'change'
					}],
					admin_password: [{
						required: true,
						min:5,
						message: '请输入管理员密码',
						trigger: 'change'
					}],
					admin_password2: [{
						required: true,
						validator: admin_password2,
						trigger: 'change'
					}]
				}
			}
		},
		mounted() {

		},
		methods: {
			resetForm() {
				this.$refs['form'].resetFields();
			},
			addAdmin() {
				var sub = true;
				var that = this;
				this.$refs['form'].validate((valid) => {
					sub = valid;
				});
				if (!sub) {
					return;
				}
				that.$axios.post('zuche/admin/addAdmin', that.form).then(function(res) {
					if (res.data.success) {
						that.$message.success('添加成功');
						that.resetForm();
					} else {
						that.$message.error(res.data.message);
					}
				});

			},

			
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tianjiazhanghao.vue